import FolderZipIcon from "@mui/icons-material/FolderZip";

export default FolderZipIcon;
